import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { DormitoryServicePath, STATE_SUBSIDIES } from "utils/constants";
import permissions from "app/permissions";
import ListStateSubsidies from "./List";

export const resources = {
  isMenu: true,
  icon: <AccountBalanceIcon />,
  name: DormitoryServicePath + STATE_SUBSIDIES,
  title: "Държавни субсидии",
  list: <ListStateSubsidies />,
  permission: permissions.canPreviewDormitoryStateSubsidies,
};
